import { useEffect, useState, useRef } from 'react'
import { toast } from 'sonner'

export function PwaInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null)
  const toastShownRef = useRef(false)

  useEffect(() => {
    const handler = (e: any) => {
      e.preventDefault()
      setDeferredPrompt(e)
    }

    window.addEventListener('beforeinstallprompt', handler)

    return () => {
      window.removeEventListener('beforeinstallprompt', handler)
    }
  }, [])

  useEffect(() => {
    if (deferredPrompt && !toastShownRef.current) {
      toastShownRef.current = true
      toast('Install Path of Mastery', {
        description: 'Install this app on your device for a better experience.',
        action: {
          label: 'Install',
          onClick: async () => {
            deferredPrompt.prompt()
            const { outcome } = await deferredPrompt.userChoice
            if (outcome === 'accepted') {
              setDeferredPrompt(null)
            }
          },
        },
        duration: 10000,
      })
    }
  }, [deferredPrompt])

  return null
}
